<div class="min-h-screen bg-gray-50">
  <!-- Header -->
  <app-navbar></app-navbar>

  <div class="relative bg-gradient-to-br from-[#2c5f8d] via-[#4A90E2] to-[#5ba3ef] text-white overflow-hidden">
    <div class="absolute inset-0 opacity-10">
      <img src="/university-students-graduating-ceremony-profession.jpg" alt="Background"
        class="w-full h-full object-cover" />
    </div>
    <div class="relative max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-12 md:py-16">
      <div class="max-w-3xl">
        <h2 class="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 sm:mb-4">
          Portal de Concursos e Processos Seletivos
        </h2>
        <p class="text-base sm:text-lg md:text-xl text-white/95 mb-6 sm:mb-8 leading-relaxed">
          Encontre as melhores oportunidades de empregos públicos e privados. Processos
          transparentes, seguros e com total suporte ao candidato.
        </p>

        <div class="max-w-2xl relative">
          <app-icon name="search"
            className="absolute left-3 sm:left-4 top-1/2 -translate-y-1/2 w-4 h-4 sm:w-5 sm:h-5 text-gray-400"></app-icon>
          <input type="text" [(ngModel)]="searchTerm" (keyup.enter)="onSearch()"
            placeholder="Buscar por cargo, área de atuação, edital..."
            class="w-full pl-10 sm:pl-12 pr-4 h-12 sm:h-14 text-sm sm:text-base bg-white shadow-lg border-0 rounded-xl text-gray-900" />
          <button (click)="onSearch()"
            class="absolute right-2 top-1/2 -translate-y-1/2 px-4 sm:px-6 h-9 sm:h-10 bg-[#4A90E2] text-white rounded-lg font-semibold hover:bg-[#357ABD] transition-colors text-sm sm:text-base">
            Buscar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-8 md:py-12">
    <!-- Tabs and View Toggle -->
    <div class="flex items-center justify-between mb-6 sm:mb-8 gap-4">
      <div
        class="grid grid-cols-4 gap-1 sm:gap-2 flex-1 bg-white border border-gray-200 rounded-2xl sm:rounded-3xl p-1">
        <button (click)="setActiveTab('INSCRICOES_ABERTAS')" [class.bg-[#4A90E2]]="activeTab === 'INSCRICOES_ABERTAS'"
          [class.text-white]="activeTab === 'INSCRICOES_ABERTAS'"
          [class.text-gray-700]="activeTab !== 'INSCRICOES_ABERTAS'"
          class="py-2 sm:py-3 px-2 sm:px-4 rounded-xl sm:rounded-2xl text-xs sm:text-sm md:text-base font-semibold transition-colors">
          Inscrições Abertas
        </button>
        <button (click)="setActiveTab('EM_ANDAMENTO')" [class.bg-[#4A90E2]]="activeTab === 'EM_ANDAMENTO'"
          [class.text-white]="activeTab === 'EM_ANDAMENTO'" [class.text-gray-700]="activeTab !== 'EM_ANDAMENTO'"
          class="py-2 sm:py-3 px-2 sm:px-4 rounded-xl sm:rounded-2xl text-xs sm:text-sm md:text-base font-semibold transition-colors">
          Em Andamento
        </button>
        <button (click)="setActiveTab('FUTUROS')" [class.bg-[#4A90E2]]="activeTab === 'FUTUROS'"
          [class.text-white]="activeTab === 'FUTUROS'" [class.text-gray-700]="activeTab !== 'FUTUROS'"
          class="py-2 sm:py-3 px-2 sm:px-4 rounded-xl sm:rounded-2xl text-xs sm:text-sm md:text-base font-semibold transition-colors">
          Futuros
        </button>
        <button (click)="setActiveTab('FINALIZADO')" [class.bg-[#4A90E2]]="activeTab === 'FINALIZADO'"
          [class.text-white]="activeTab === 'FINALIZADO'" [class.text-gray-700]="activeTab !== 'FINALIZADO'"
          class="py-2 sm:py-3 px-2 sm:px-4 rounded-xl sm:rounded-2xl text-xs sm:text-sm md:text-base font-semibold transition-colors">
          Finalizados
        </button>
      </div>
      <app-view-toggle></app-view-toggle>
    </div>

    <div *ngIf="isLoading"
      [ngClass]="viewMode === 'grid' ? 'grid gap-4 sm:gap-6 sm:grid-cols-2 lg:grid-cols-3' : 'space-y-4'">
      <div *ngFor="let i of skeletons" [ngClass]="viewMode === 'grid' 
             ? 'bg-white rounded-lg border border-gray-200 p-4 sm:p-6 h-full relative animate-pulse' 
             : 'bg-white rounded-lg border border-gray-200 p-4 sm:p-6 relative flex gap-4 sm:gap-6 animate-pulse'">

        <div [ngClass]="viewMode === 'grid' 
          ? 'absolute top-3 right-3 sm:top-4 sm:right-4 w-20 h-20 sm:w-28 sm:h-28 rounded-lg bg-gray-200' 
          : 'w-24 h-24 sm:w-32 sm:h-32 rounded-lg bg-gray-200 flex-shrink-0'">
        </div>

        <div [ngClass]="viewMode === 'grid' ? 'mb-2 sm:mb-3 pr-24 sm:pr-36 w-full' : 'flex-1 min-w-0 py-2'">
          <div class="h-5 w-24 bg-gray-200 rounded-full mb-3"></div>

          <div class="h-6 w-3/4 bg-gray-200 rounded mb-2"></div>
          <div class="h-6 w-1/2 bg-gray-200 rounded mb-3"></div>

          <div class="h-4 w-1/3 bg-gray-200 rounded mb-4"></div>

          <div *ngIf="viewMode === 'list'" class="flex items-center gap-4 mt-4">
            <div class="h-4 w-20 bg-gray-200 rounded"></div>
            <div class="h-4 w-20 bg-gray-200 rounded"></div>
            <div class="h-4 w-32 bg-gray-200 rounded"></div>
          </div>
        </div>

        <div *ngIf="viewMode === 'grid'" class="space-y-3 mt-8">
          <div class="h-4 w-full bg-gray-200 rounded"></div>
          <div class="h-4 w-2/3 bg-gray-200 rounded"></div>
          <div class="h-4 w-3/4 bg-gray-200 rounded"></div>

          <div class="pt-4 mt-2 border-t border-gray-100">
            <div class="h-4 w-32 bg-gray-200 rounded"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="!isLoading && getConcursosByTab().length === 0" class="text-center py-12">
      <app-icon name="inbox" className="w-16 h-16 mx-auto text-gray-400 mb-4"></app-icon>
      <p class="text-gray-600 text-lg">Nenhum concurso encontrado nesta categoria.</p>
    </div>

    <div *ngIf="!isLoading"
      [ngClass]="viewMode === 'grid' ? 'grid gap-4 sm:gap-6 sm:grid-cols-2 lg:grid-cols-3' : 'space-y-4'">
      <a *ngFor="let concurso of getConcursosByTab()" [routerLink]="['/portal/concurso', concurso.id]" class="block">
        <div
          [ngClass]="viewMode === 'grid' 
            ? 'bg-white rounded-lg border border-gray-200 p-4 sm:p-6 hover:shadow-lg transition-shadow h-full relative' 
            : 'bg-white rounded-lg border border-gray-200 p-4 sm:p-6 hover:shadow-lg transition-shadow relative flex gap-4 sm:gap-6'">
          <div *ngIf="concurso.fotoUrl"
            [ngClass]="viewMode === 'grid' 
              ? 'absolute top-3 right-3 sm:top-4 sm:right-4 w-20 h-20 sm:w-28 sm:h-28 rounded-lg overflow-hidden bg-white flex items-center justify-center flex-shrink-0' 
              : 'w-24 h-24 sm:w-32 sm:h-32 rounded-lg overflow-hidden bg-white flex items-center justify-center flex-shrink-0'">
            <img [src]="concurso.fotoUrl" [alt]="concurso.nome" class="w-full h-full object-contain p-1.5" />
          </div>

          <div [ngClass]="viewMode === 'grid' ? 'mb-2 sm:mb-3 pr-24 sm:pr-36' : 'flex-1 min-w-0'">
            <div class="flex-1 min-w-0">
              <div class="flex items-center gap-2 mb-2 flex-wrap">
                <span [class]="getStatusColor(concurso.tag)"
                  class="text-white shrink-0 px-2 py-1 rounded-full text-xs font-medium">
                  {{ getStatusLabel(concurso.tag) }}
                </span>
              </div>
              <h3 class="font-bold text-gray-900 text-base sm:text-lg leading-tight mb-1">
                {{ concurso.numeroEdital }} - {{ concurso.nome }}
              </h3>
              <p class="text-gray-700 text-sm sm:text-base font-semibold mb-2">{{ concurso.orgaoNome }}</p>

              <div *ngIf="viewMode === 'list'" class="flex items-center gap-4 sm:gap-6 flex-wrap mt-2">
                <div class="flex items-center text-gray-600 text-sm">
                  <app-icon name="users" className="w-4 h-4 mr-2 text-[#4A90E2]"></app-icon>
                  <span>
                    <strong class="text-gray-900">{{ concurso.vagasFormatadas }}</strong>
                    <span class="text-gray-500 ml-1">vagas</span>
                  </span>
                </div>
                <div class="flex items-center text-gray-600 text-sm">
                  <app-icon name="briefcase" className="w-4 h-4 mr-2 text-[#4A90E2]"></app-icon>
                  <span>
                    <strong class="text-gray-900">{{ concurso.totalCargos }}</strong>
                    <span class="text-gray-500 ml-1">{{ concurso.totalCargos === 1 ? 'cargo' : 'cargos' }}</span>
                  </span>
                </div>
                <div class="flex items-center text-gray-600 text-sm" *ngIf="getInscriptionStage(concurso)">
                  <app-icon name="calendar" className="w-4 h-4 mr-2 text-[#4A90E2]"></app-icon>
                  <span>
                    <strong class="text-gray-900">
                      {{ formatDateTime(getInscriptionStage(concurso)!.dtInicio) }} até {{
                      formatDateTime(getInscriptionStage(concurso)!.dtFim) }}
                    </strong>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div [ngClass]="viewMode === 'grid' 
            ? 'space-y-1.5 sm:space-y-2 mb-3 sm:mb-4' 
            : ''">
            <div class="flex items-center text-gray-600 text-sm"
              *ngIf="getInscriptionStage(concurso) && viewMode === 'grid'">
              <app-icon name="calendar" className="w-4 h-4 mr-2 text-[#4A90E2]"></app-icon>
              <span>
                Inscrições:
                <strong class="text-gray-900">
                  {{ formatDateTime(getInscriptionStage(concurso)!.dtInicio) }} até {{
                  formatDateTime(getInscriptionStage(concurso)!.dtFim) }}
                </strong>
              </span>
            </div>
            <div class="flex items-center text-gray-600 text-sm" *ngIf="viewMode === 'grid'">
              <app-icon name="users" className="w-4 h-4 mr-2 text-[#4A90E2]"></app-icon>
              <span>
                <strong class="text-gray-900">{{ concurso.vagasFormatadas }}</strong>
                disponíveis
              </span>
            </div>
            <div class="flex items-center text-gray-600 text-sm" *ngIf="viewMode === 'grid'">
              <app-icon name="briefcase" className="w-4 h-4 mr-2 text-[#4A90E2]"></app-icon>
              <span>
                <strong class="text-gray-900">{{ concurso.totalCargos }}</strong>
                {{ concurso.totalCargos === 1 ? 'cargo' : 'cargos' }}
              </span>
            </div>
          </div>

          <div [ngClass]="viewMode === 'grid' 
              ? 'flex items-center text-[#4A90E2] font-semibold pt-2 border-t border-gray-100' 
              : 'flex items-center text-[#4A90E2] font-semibold pt-2 border-t border-gray-100 flex-shrink-0'">
            <span>Ver detalhes do edital</span>
            <svg class="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
            </svg>
          </div>
        </div>
      </a>
    </div>
  </div>

  <!-- Footer -->
  <app-footer></app-footer>
</div>
